export default __webpack_public_path__ + "static/media/32.42e5be12.jpg";